import { configureStore } from '@reduxjs/toolkit';
import configReducer from './slices/configSlice';
import companiesReducer from './slices/companiesSlice';
import sensorDataReducer from './slices/sensorDataSlice';

export const store = configureStore({
  reducer: {
    config: configReducer,
    companies: companiesReducer,
    sensorData: sensorDataReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
